import { Action, config, Module, Mutation, VuexModule } from "vuex-module-decorators";
import store from "@/store";
import { API, Auth } from "aws-amplify";

config.rawError = true

const API_NAME = "Viewpoint360API";
const name = 'userauth';
// if (module.hot) {
//     if (store.hasModule(name)) {
//         store.unregisterModule(name);
//     }
// }

@Module({dynamic: true, store, name: name, namespaced: true})
export default class UserAuth extends VuexModule {

    isGuest: boolean = false;
    user: any = null;

    @Mutation
    setUser(user: any) {
        this.user = user;
    }

    @Mutation
    setGuest(guest: boolean) {
        this.isGuest = guest
    }

    get userId() {
        if (this.user) {
            return this.user.userId;
        } else {

        }
    }

    @Action
    async getUser() {
        this.setUser(null)
        if (this.user) return this.user;
        try {
            let currentUser = await Auth.currentAuthenticatedUser()
            let userId = currentUser.getUsername()
            let user = await API.get(API_NAME, `/users/${userId}`, {});
            this.setGuest(false)
            this.setUser(user)
            return user;
        } catch (e) {
            await Auth.currentUserCredentials()
            this.setGuest(true)
        }

    }

    @Action
    async signOut() {
        this.setUser(null);
        this.setGuest(false);
        this.getUser();
    }

}